<template>
  <div class="entire_client_app__sidebar">
    <div
      :class="{
        '--sidebar_toggled_expd_logo_container':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
      class="logo_container"
    >
      <div
        :class="{ '--full_width': $store.state.SidebarToggle.sidebar_toggled }"
        class="menu_toggle"
        @click="$store.commit('SidebarToggle/togglesidebar')"
      >
        <svg
          id="menu"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 28 28"
        >
          <path id="Path_1" data-name="Path 1" d="M0,0H28V28H0Z" fill="none" />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M18.889,21.5V24H5.444V21.5ZM25,12.75v2.5H3v-2.5ZM22.556,4V6.5H9.111V4Z"
            transform="translate(0)"
            fill="#1d2329"
          />
        </svg>
      </div>
      <div
        :class="{
          '--sidebar_toggled_hide_logo':
            $store.state.SidebarToggle.sidebar_toggled,
        }"
        class="logo"
      >
        <img src="../assets/logo.png" alt="logo" />
      </div>
      <div
        :class="{ '--full_width': $store.state.SidebarToggle.sidebar_toggled }"
        class="settings"
      >
        <router-link to="/admin/profile"
          ><svg
            id="settings"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 28 28"
          >
            <path
              id="Path_3"
              data-name="Path 3"
              d="M0,0H28V28H0Z"
              fill="none"
            />
            <path
              id="Path_4"
              data-name="Path 4"
              d="M2,14a12.19,12.19,0,0,1,.379-3.024A3.6,3.6,0,0,0,5.685,9.171a3.642,3.642,0,0,0-.1-3.784,11.971,11.971,0,0,1,5.2-3.025,3.59,3.59,0,0,0,6.418,0,11.971,11.971,0,0,1,5.2,3.025,3.642,3.642,0,0,0-.1,3.786,3.6,3.6,0,0,0,3.308,1.805,12.239,12.239,0,0,1,0,6.046,3.6,3.6,0,0,0-3.307,1.8,3.642,3.642,0,0,0,.1,3.785,11.971,11.971,0,0,1-5.2,3.025,3.59,3.59,0,0,0-6.418,0,11.971,11.971,0,0,1-5.2-3.025,3.642,3.642,0,0,0,.1-3.786,3.6,3.6,0,0,0-3.308-1.805A12.215,12.215,0,0,1,2,14Zm5.765,3.623a6.065,6.065,0,0,1,.677,4.255A9.594,9.594,0,0,0,10,22.783a5.975,5.975,0,0,1,8,0,9.594,9.594,0,0,0,1.556-.906,6.062,6.062,0,0,1,.677-4.255,6,6,0,0,1,3.324-2.717,9.873,9.873,0,0,0,0-1.811,6,6,0,0,1-3.325-2.717,6.062,6.062,0,0,1-.677-4.255A9.572,9.572,0,0,0,18,5.217a5.973,5.973,0,0,1-8,0,9.573,9.573,0,0,0-1.556.906,6.062,6.062,0,0,1-.677,4.255,6,6,0,0,1-3.324,2.717,9.873,9.873,0,0,0,0,1.811,6,6,0,0,1,3.325,2.717Zm6.235,0A3.623,3.623,0,1,1,17.6,14,3.611,3.611,0,0,1,14,17.623Zm0-2.415A1.208,1.208,0,1,0,12.8,14,1.2,1.2,0,0,0,14,15.208Z"
              transform="translate(0 0)"
              fill="#1d2329"
            /></svg
        ></router-link>
      </div>
    </div>
    <div
      :class="{
        '--sidebar_toggled_expd_user_account_container':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
      class="user_account_container"
    >
      <div
        :class="{
          '--sidebar_toggled_hide_user_avatar':
            $store.state.SidebarToggle.sidebar_toggled,
        }"
        class="user_avatar"
      >
        <svg
          id="Component_108_1"
          data-name="Component 108 – 1"
          xmlns="http://www.w3.org/2000/svg"
          width="169.706"
          height="169.706"
          viewBox="0 0 169.706 169.706"
        >
          <g
            id="tickets"
            transform="translate(156.472 121.998) rotate(163)"
            fill="none"
            stroke="#487fff"
            stroke-linecap="round"
            stroke-width="4"
            stroke-dasharray="29 8"
          >
            <circle cx="57.5" cy="57.5" r="57.5" stroke="none" />
            <circle cx="57.5" cy="57.5" r="55.5" fill="none" />
          </g>
          <g
            id="tickets-2"
            data-name="tickets"
            transform="translate(169.706 84.853) rotate(135)"
            fill="none"
            stroke="#eaedf4"
            stroke-linecap="round"
            stroke-width="8"
            stroke-dasharray="100 965"
          >
            <circle cx="60" cy="60" r="60" stroke="none" />
            <circle cx="60" cy="60" r="56" fill="none" />
          </g>
          <circle
            id="Ellipse_5"
            data-name="Ellipse 5"
            cx="5"
            cy="5"
            r="5"
            transform="translate(35.606 112.567)"
            fill="#59d269"
          />
        </svg>
        <div class="image">
          <img
            v-if="$store.state.UserDetails.user.photo == ''"
            src="../assets/default.png"
            alt="avatar"
          />
          <img
            v-else
            draggable="false"
            :src="$store.state.UserDetails.user.photo"
            alt="avatar"
          />
        </div>
      </div>
      <div
        :class="{
          '--sidebar_toggled_hide_user_details':
            $store.state.SidebarToggle.sidebar_toggled,
        }"
        class="user_details"
      >
        <h2>{{ user.firstname }} {{ user.lastname }}</h2>
        <div class="promo_level_container">
          <router-link to="/admin/companyProfile">
            <p>
              {{
                String(company.companyname)
                  .charAt(0)
                  .toUpperCase() +
                  String(company.companyname).slice(1) +
                  " "
              }}Admin <img src="@/assets/editicon.svg" /></p
          ></router-link>
        </div>
      </div>
    </div>
    <div
      :class="{
        '--sidebar_toggled_hide_nav_container':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
      class="navigation_container"
    >
      <div class="navigation_links">
        <router-link to="/admin/dashboard">
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                id="dashboard-line"
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
              >
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M0,0H28V28H0Z"
                  fill="none"
                />
                <path
                  class="active_icon"
                  id="Path_14"
                  data-name="Path 14"
                  d="M15.222,25V12.778H25V25ZM3,15.222V3h9.778V15.222Zm7.333-2.444V5.444H5.444v7.333ZM3,25V17.667h9.778V25Zm2.444-2.444h4.889V20.111H5.444Zm12.222,0h4.889V15.222H17.667ZM15.222,3H25v7.333H15.222Zm2.444,2.444V7.889h4.889V5.444Z"
                  transform="translate(0 0)"
                  fill="#1D2329"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Dashboard
            </div>
          </div>
        </router-link>

        <router-link to="/admin/transactions">
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                id="exchange-funds-line"
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
              >
                <path
                  id="Path_100"
                  data-name="Path 100"
                  d="M0,0H28V28H0Z"
                  fill="none"
                />
                <path
                  class="active_icon"
                  id="Path_101"
                  data-name="Path 101"
                  d="M22.785,17.724A9.649,9.649,0,0,0,20.321,6.812,9.476,9.476,0,0,0,9.271,5.664L8.089,3.579a11.832,11.832,0,0,1,11.867.029,12.046,12.046,0,0,1,4.9,15.324l1.6.929L21.5,22.517l-.2-5.657,1.484.863ZM5.215,10.276A9.649,9.649,0,0,0,7.68,21.188a9.476,9.476,0,0,0,11.05,1.149l1.182,2.084a11.832,11.832,0,0,1-11.867-.029A12.046,12.046,0,0,1,3.14,9.068l-1.6-.928L6.5,5.484l.2,5.657-1.484-.863Zm10.471,7.117L12.313,14,8.945,17.394,7.26,15.7l5.054-5.09L15.684,14l3.37-3.394,1.684,1.7-5.054,5.09Z"
                  transform="translate(0 0)"
                  fill="#1D2329"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Transactions
            </div>
          </div>
        </router-link>

        <router-link to="/admin/branches">
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                id="route-line"
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
              >
                <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M0,0H28V28H0Z"
                  fill="none"
                />
                <path
                  class="active_icon"
                  id="Path_18"
                  data-name="Path 18"
                  d="M4.571,15V8.5c0-2.485,2.4-4.5,5.357-4.5s5.357,2.015,5.357,4.5v7A2.769,2.769,0,0,0,18.262,18a2.769,2.769,0,0,0,2.976-2.5V8.83a2.983,2.983,0,0,1-2.331-3.337A3.454,3.454,0,0,1,22.428,3,3.454,3.454,0,0,1,25.95,5.493,2.983,2.983,0,0,1,23.619,8.83V15.5c0,2.485-2.4,4.5-5.357,4.5S12.9,17.985,12.9,15.5v-7A2.769,2.769,0,0,0,9.928,6,2.769,2.769,0,0,0,6.952,8.5V15h3.571L5.762,20,1,15ZM22.428,7a1.108,1.108,0,0,0,1.19-1,1.209,1.209,0,0,0-2.381,0A1.108,1.108,0,0,0,22.428,7Z"
                  transform="translate(0)"
                  fill="#1d2329"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Branches
            </div>
          </div>
        </router-link>

        <router-link to="/admin/buses">
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                id="Group_146"
                data-name="Group 146"
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
              >
                <path
                  id="Path_213"
                  data-name="Path 213"
                  d="M0,0H24V24H0Z"
                  fill="none"
                />
                <path
                  class="active_icon"
                  id="Path_214"
                  data-name="Path 214"
                  d="M17,20H7v1a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V12H2V8H3V5A2,2,0,0,1,5,3H19a2,2,0,0,1,2,2V8h1v4H21v9a1,1,0,0,1-1,1H18a1,1,0,0,1-1-1ZM5,5v6H19V5Zm14,8H5v5H19ZM7.5,17A1.5,1.5,0,1,1,9,15.5,1.5,1.5,0,0,1,7.5,17Zm9,0A1.5,1.5,0,1,1,18,15.5,1.5,1.5,0,0,1,16.5,17Z"
                  fill="#1d2329"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Buses
            </div>
          </div>
        </router-link>

        <router-link to="/admin/routes">
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                id="Group_147"
                data-name="Group 147"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  id="Path_217"
                  data-name="Path 217"
                  d="M0,0H24V24H0Z"
                  fill="none"
                />
                <path
                  class="active_icon"
                  id="Path_218"
                  data-name="Path 218"
                  d="M21,19h2v2H1V19H3V4A1,1,0,0,1,4,3H14a1,1,0,0,1,1,1V19h4V11H17V9h3a1,1,0,0,1,1,1ZM5,5V19h8V5Zm2,6h4v2H7ZM7,7h4V9H7Z"
                  fill="#1d2329"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Routes
            </div>
          </div>
        </router-link>

        <router-link to="/admin/workers">
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                id="users"
                xmlns="http://www.w3.org/2000/svg"
                width="28.011"
                height="24.898"
                viewBox="0 0 28.011 24.898"
              >
                <path
                  class="active_icon"
                  id="Path_1236"
                  data-name="Path 1236"
                  d="M20.449,20.069V18.786A6.95,6.95,0,0,0,23.562,13c0-3.868,0-7-4.668-7s-4.668,3.135-4.668,7a6.949,6.949,0,0,0,3.112,5.783v1.283C12.058,20.5,8,23.095,8,26.23H29.786C29.786,23.095,25.728,20.5,20.449,20.069Z"
                  transform="translate(-1.775 -1.332)"
                  fill="#373A3D"
                />
                <path
                  class="active_icon"
                  id="Path_1237"
                  data-name="Path 1237"
                  d="M7.956,19.338a14.768,14.768,0,0,1,4.858-1.955,8.815,8.815,0,0,1-.984-1.435A8.915,8.915,0,0,1,10.7,11.671a13.82,13.82,0,0,1,.744-5.684,5.067,5.067,0,0,1,3.872-2.905C14.9,1.222,13.808,0,10.893,0,6.225,0,6.225,3.135,6.225,7a6.949,6.949,0,0,0,3.112,5.783v1.283C4.058,14.5,0,17.094,0,20.229H6.784a9.981,9.981,0,0,1,1.172-.892Z"
                  fill="#373A3D"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Workers
            </div>
          </div>
        </router-link>

        <router-link to="/admin/companyDetailsRegistration">
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M16.596 1.04l6.347 6.346a.5.5 0 0 1-.277.848l-1.474.23-5.656-5.656.212-1.485a.5.5 0 0 1 .848-.283zM4.595 20.15c3.722-3.331 7.995-4.328 12.643-5.52l.446-4.018-4.297-4.297-4.018.446c-1.192 4.648-2.189 8.92-5.52 12.643L2.454 18.01c2.828-3.3 3.89-6.953 5.303-13.081l6.364-.707 5.657 5.657-.707 6.364c-6.128 1.414-9.782 2.475-13.081 5.303L4.595 20.15zm5.284-6.03a2 2 0 1 1 2.828-2.828A2 2 0 0 1 9.88 14.12z" fill="rgba(52,72,94,1)"/></svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Register All At Once
            </div>
          </div>
        </router-link>

        <router-link to="/admin/support">
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                id="customer-service-2-line"
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
              >
                <path
                  id="Path_23"
                  data-name="Path 23"
                  d="M0,0H28V28H0Z"
                  fill="none"
                />
                <path
                  class="active_icon"
                  id="Path_24"
                  data-name="Path 24"
                  d="M23.381,9.273h1.255A2.364,2.364,0,0,1,27,11.636v4.727a2.364,2.364,0,0,1-2.364,2.364H23.381A9.456,9.456,0,0,1,14,27V24.636a7.091,7.091,0,0,0,7.091-7.091V10.454a7.091,7.091,0,1,0-14.182,0v8.273H3.364A2.364,2.364,0,0,1,1,16.364V11.636A2.364,2.364,0,0,1,3.364,9.273H4.619a9.456,9.456,0,0,1,18.763,0ZM3.364,11.636v4.727H4.545V11.636Zm20.091,0v4.727h1.182V11.636ZM8.989,18.473l1.253-2a7.1,7.1,0,0,0,7.516,0l1.253,2a9.461,9.461,0,0,1-10.022,0Z"
                  transform="translate(0)"
                  fill="#1d2329"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Support
            </div>
          </div>
        </router-link>
        <router-link to="/dashboard">
          <div class="navigation_link_content">
            <div
              :class="{
                '--sidebar_toggled_hide_link_icon_full_width':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_icon"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M12 2c3.5 0 6 3 7 6 3 1 4 3.73 4 6l-2.775.793a1 1 0 0 0-.725.961v1.496A1.75 1.75 0 0 1 17.75 19h-.596a2 2 0 0 0-1.668.896C14.558 21.3 13.396 22 12 22c-1.396 0-2.558-.701-3.486-2.104A2 2 0 0 0 6.846 19H6.25a1.75 1.75 0 0 1-1.75-1.75v-1.496a1 1 0 0 0-.725-.961L1 14c0-2.266 1-5 4-6 1-3 3.5-6 7-6zm0 2C9.89 4 7.935 5.788 6.989 8.371l-.092.261-.316.95-.949.315c-1.255.419-2.067 1.341-2.424 2.56l-.023.086 1.14.327a3 3 0 0 1 2.17 2.703l.005.181V17h.346a4 4 0 0 1 3.2 1.6l.136.192C10.758 19.663 11.316 20 12 20c.638 0 1.167-.293 1.703-1.04l.115-.168a4 4 0 0 1 3.1-1.785l.236-.007h.346v-1.246a3 3 0 0 1 2.003-2.83l.173-.054 1.139-.327-.023-.087c-.337-1.151-1.08-2.037-2.22-2.484l-.204-.075-.95-.316-.315-.949C16.195 5.91 14.18 4 12 4zm0 8c.828 0 1.5 1.12 1.5 2.5S12.828 17 12 17s-1.5-1.12-1.5-2.5.672-2.5 1.5-2.5zM9.5 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
                />
              </svg>
            </div>
            <div
              :class="{
                '--sidebar_toggled_hide_link_name':
                  $store.state.SidebarToggle.sidebar_toggled,
              }"
              class="link_name"
            >
              Client-dashboard
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div
      :class="{
        '--sidebar_toggled_log_btn_full':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
      class="logout_btn"
    >
      <button @click="logout">
        Logout
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="15"
          height="15"
        >
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2a9.985 9.985 0 0 1 8 4h-2.71a8 8 0 1 0 .001 12h2.71A9.985 9.985 0 0 1 12 22zm7-6v-3h-8v-2h8V8l5 4-5 4z"
            fill="#ffffff"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import router from "../router/index";
import capitalizeStringMixin from "../mixins/capitalizeStringMixin";
export default {
  name: "Sidebar",
  data() {
    return {
      user: new String(),
      company: new String(),
    };
  },
  mixins: [capitalizeStringMixin],
  methods: {
    logout() {
      localStorage.removeItem("jwt");
      localStorage.removeItem("companyId");
      localStorage.removeItem("companyName");
      router.push("/");
    },
    checkIfLoadingIsDone() {
      if (
        this.$store.state.UserDetails.user.firstname != undefined &&
        this.$store.state.UserDetails.user.firstname != null &&
        this.$store.state.UserDetails.user != []
      ) {
        this.$store.commit("SidebarToggle/updateLoadingNumber");
      } else {
        let checkInter = setInterval(() => {
          if (
            this.$store.state.UserDetails.user.firstname != undefined &&
            this.$store.state.UserDetails.user.firstname != null &&
            this.$store.state.UserDetails.user != []
          ) {
            this.$store.commit("SidebarToggle/updateLoadingNumber");
            clearInterval(checkInter);
          }
        }, 3000);
      }
    },
  },
  computed: {
    user() {
      var userDataToDisplay = this.$store.state.UserDetails.user;
      return Object.assign(this.user, userDataToDisplay);
    },
    company() {
      var companyDataToDisplay = this.$store.state.UserDetails.company;
      return Object.assign(this.company, companyDataToDisplay);
    },
  },
  mounted() {
    this.$store.dispatch("UserDetails/getUser");
    this.$store.dispatch("UserDetails/getCompany");
    this.checkIfLoadingIsDone();
  },
};
</script>

<style lang="scss" scoped>
.entire_client_app__sidebar {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  /* justify-content: space-around; */
  flex-direction: column;
  & .--sidebar_toggled_expd_logo_container {
    height: 11% !important;
  }
  & .logo_container {
    width: 100%;
    height: 8%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 5%;
    .menu_toggle {
      width: 22%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .--full_width {
      width: 100% !important;
      height: 50% !important;
    }
    .--sidebar_toggled_hide_logo {
      display: none !important;
    }
    .logo {
      width: 56%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 80%;
        margin-top: 0.2em;
      }
    }
    .settings {
      width: 22%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
  & .--sidebar_toggled_expd_user_account_container {
    height: 10% !important;
  }
  & .user_account_container {
    height: 25%;
    width: 100%;
    .--sidebar_toggled_hide_user_avatar {
      height: 100% !important;
      & .image {
        // width: 40% !important;
        width: 2.3em !important;
        height: 2.3em !important;
      }
      & svg {
        width: 76% !important;
        position: absolute;
      }
    }
    .user_avatar {
      height: 50%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      & svg {
        width: 52%;
        // width: 8em;
        // height: 8em;
        transform: rotate(265deg);

        position: absolute;
      }

      & .image {
        width: 4.3em;
        height: 4.3em;
        overflow: hidden;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: $routeShadows;

        img {
          width: auto;
          max-width: 100%;
          height: auto;
          max-height: 100%;
        }
      }
    }
    .--sidebar_toggled_hide_user_details {
      display: none !important;
    }
    .user_details {
      height: 50%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      h2 {
        color: $mainDark;
        font-family: satoshi, $poppins;
        font-size: 1.1em;
      }
      .promo_level_container {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        p {
          font-family: satoshi, $poppins;
          font-size: 0.8em;
          font-weight: 500;
          color: $dimerDark;
          cursor: pointer;
        }
      }
    }
  }
  & .navigation_container {
    /* background-color: $mainBlueLight; */
    height: 30%;
    width: 100%;
    margin-top: -0.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    .navigation_links {
      width: 95%;
      height: 100%;
      border-radius: 0.25em;
      .navigation_link_content {
        width: 100%;
        height: 20%;
        border-radius: 0.22em;
        display: flex;
        align-items: center;
        .--sidebar_toggled_hide_link_icon_full_width {
          width: 100% !important;
          svg {
            width: 28% !important;
          }
        }
        .link_icon {
          width: 20%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            width: 45%;
          }
        }
        .--sidebar_toggled_hide_link_name {
          display: none !important;
        }
        .link_name {
          width: 80%;
          height: 100%;
          display: flex;
          align-items: center;
          font-family: satoshi, $poppins;
          font-size: 0.85em;
          font-weight: 580;
        }
      }
    }
  }
  .--sidebar_toggled_hide_nav_container {
    margin-top: 10%;
  }
  & .--sidebar_toggled_log_btn_full {
    button {
      padding: 0.3em 1.2em !important;
      font-size: 0.76em !important;
      border-radius: 0.7em !important;
    }
  }
  & .logout_btn {
    width: 100%;
    height: 15%;
    display: flex;
    position: absolute;
    bottom: -1em !important;
    justify-content: center;
    margin-top: 50%;
    align-items: center;
    button {
      border: none;
      padding: 0.6em 2em;
      border-radius: 0.3em;
      font-family: satoshi, $poppins;
      font-size: 0.82em;
      color: $pureWhite;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      background-color: $mainBlue;

      svg {
        margin-left: 0.8em;
      }
    }
  }
}
</style>
